import React from "react";
import useMedia from "react-use/lib/useMedia";
import { Typography } from "../Typography";
import { Link } from "../Link";
import styled from "@emotion/styled";

const TakeToAccountContainer = styled.section`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.mist};
  padding: 58px 24px 60px 24px;
`;

const ContainerTitle = styled(Typography)`
  text-align: center;
  padding-bottom: 23px;
`;

const ContentLink = styled(Link)`
  text-align: center;
  color: ${({ theme }) => theme.colors.charcoal};
  font-size: 18px;
  &:first-of-type {
    padding-bottom: 12px;
  }
`;

export const TakeToAccount = () => {
  const isMobile = useMedia("(max-width: 1024px)");
  return isMobile ? (
    <TakeToAccountContainer>
      <ContainerTitle use="sectionTitle" as="h2">
        Where next?
      </ContainerTitle>
      <ContentLink href={`/account`} title="Account overview">
        Account overview
      </ContentLink>
      <ContentLink href={`/profile`} title="My profile">
        My profile
      </ContentLink>
    </TakeToAccountContainer>
  ) : null;
};
